/**
 * Component Registry for Passage
 * 
 * Inherits from @vibesites-amc-preferred-theme/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc-preferred-theme/theme-preferred/registry';
import { PageBlurb } from './components/PageBlurb';
import { PropertyOverview } from './components/PropertyOverview';
import { NeighborhoodCallout } from './components/NeighborhoodCallout';
import { ReviewsCallout } from './components/ReviewsCallout';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Local PageBlurb normalizes manually-pasted inner-page blurbs (with inline
  // formatting and hyperlinks) so they render with the same styling and link
  // behavior as the default field-bound blurb on the Pet Policy page.
  PageBlurb,
  // Local overrides of the inherited PropertyOverview and NeighborhoodCallout
  // so their descriptions use the same font styling as PageBlurb — including
  // the descendant resets that force pasted inline font/size/color to inherit
  // the theme typography — for consistent body copy across the site.
  PropertyOverview,
  NeighborhoodCallout,
  // Local override sorts featured reviews newest-first before taking the top three.
  ReviewsCallout,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
